export const module17InitialState = {
  module17: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      Hat: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Bow: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      KitePurple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      KitePink: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ButterflyBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ButterflyPink: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PlaygroundBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PlaygroundRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Baseball: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Ball: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PondMallardDuck: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PondWhiteDuck: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandChurros: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandPopsicle: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SkateboardRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SkateboardBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      DogInBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      DogInRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module17Reducer = (state = module17InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE17_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        Hat: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Bow: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        KitePurple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        KitePink: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ButterflyBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ButterflyPink: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PlaygroundBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PlaygroundRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Baseball: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Ball: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PondMallardDuck: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PondWhiteDuck: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandChurros: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandPopsicle: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SkateboardRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SkateboardBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        DogInBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        DogInRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"Hat\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"ButterflyBlue\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"ButterflyBlue\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"PlaygroundBlue\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SkateboardBlue\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module17: {
          ...state.module17,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module17InitialState,
      };
    }
    case 'MODULE17_SET_DAY': {
      return {
        ...state,
        module17: {
          ...state.module17,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE17_SET_GameDetials': {
      return {
        ...state,
        module17: {
          ...state.module17,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE17_SET_stepCompleted': {
      return {
        ...state,
        module17: {
          ...state.module17,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE17_SET_dayCompleted': {
      return {
        ...state,
        module17: {
          ...state.module17,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE17_SET_CAMERAOPEN': {
      return {
        ...state,
        module17: {
          ...state.module17,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE17_SET_KEY': {
      return {
        ...state,
        module17: {
          ...state.module17,
          keys: action.payload,
        },
      };
    }
    case 'MODULE17_SET_COIN': {
      return {
        ...state,
        module17: {
          ...state.module17,
          coins: action.payload,
        },
      };
    }
    case 'MODULE17_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module17: {
          ...state.module17,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE17_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module17: {
          ...state.module17,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE17_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module17: {
          ...state.module17,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE17_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module17: {
          ...state.module17,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE17_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module17: {
          ...state.module17,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE17_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module17: {
          ...state.module17,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE17_SET_REWARD11': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Hat: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD11_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Hat: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD12': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Bow: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD12_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Bow: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD21': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            KitePurple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD21_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            KitePurple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD22': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            KitePink: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD22_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            KitePink: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD31': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            ButterflyBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD31_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            ButterflyBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD32': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            ButterflyPink: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD32_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            ButterflyPink: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD41': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PlaygroundBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD41_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PlaygroundBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD42': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PlaygroundRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD42_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PlaygroundRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD51': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Baseball: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD51_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Baseball: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD52': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Ball: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD52_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            Ball: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD61': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PondMallardDuck: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD61_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PondMallardDuck: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD62': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PondWhiteDuck: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD62_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            PondWhiteDuck: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD71': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            StandChurros: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD71_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            StandChurros: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD72': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            StandPopsicle: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD72_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            StandPopsicle: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD81': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            SkateboardRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD81_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            SkateboardRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD82': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            SkateboardBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_REWARD82_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            SkateboardBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_PRIZE1': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            DogInBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            DogInBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_PRIZE2': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            DogInRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module17: {
          ...state.module17,
          rewards: {
            ...state.module17.rewards,
            DogInRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE17_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module17: {
          ...state.module17,
          unlockedDays: {
            ...state.module17.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module17Reducer;
